import { render, staticRenderFns } from "./FormUserApprovalConfig.vue?vue&type=template&id=c13f2742&"
import script from "./FormUserApprovalConfig.vue?vue&type=script&lang=js&"
export * from "./FormUserApprovalConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormUserApprovalConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports